import { Box, Center } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  return (
    <Center>
      <Box
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();
          navigate("/auth/forgot-password");
        }}
        mx={"auto"}
        textAlign={"center"}
        as="button"
        fontSize={"sm"}
        textDecor={"underline"}
        sx={{
          color: "primary.500",
          "&:hover": {
            color: "primary.600",
          },
        }}
      >
        Forgot your password?
      </Box>
    </Center>
  );
};

export default ForgotPassword;
